/* eslint-disable @next/next/link-passhref */
import Link from "next/link";
import ApnaTimeLogo from "../../assets/svgs/ApnaTimeLogo";

const LogoLink = () => (
	<Link href="/" aria-label="Apna Home">
		<ApnaTimeLogo />
	</Link>
);

export default LogoLink;
